import type { IConfigPortalCredentialRepository } from "@src/domain/repositories/config";
import type { DeleteConfigPortalCredentialDTO } from "@src/domain/dto/config";

export class DeleteConfigPortalCredentialUseCase {
  private readonly repository: IConfigPortalCredentialRepository;

  constructor(repository: IConfigPortalCredentialRepository) {
    this.repository = repository;
  }

  execute(params: DeleteConfigPortalCredentialDTO) {
    return this.repository.deletePortalCredential(params);
  }
}
